import clsx from "clsx";
import React, { PureComponent } from "react";
import { DatePicker } from "@material-ui/pickers";
import { createStyles } from "@material-ui/styles";
import { IconButton, withStyles } from "@material-ui/core";
import MyToolbar from "./WkToolbar";
import moment from "moment";
import { muiThemePicker } from '../mui-theme-design';
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import {logger} from '../utils';

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiButton-label": {
            color: "#1f1b1e"
        },
        "& .Mui-checked": {
            color: '#1f1b1e'
        },

    },
}));
moment.updateLocale("en", {
    week: {
        dow: 1
    }
});

class CustomElements extends PureComponent {
    state = {
        selectedDate: this.props.week
    };

    handleWeekChange = date => {
        this.setState({ selectedDate: date.startOf("isoWeek") });
        this.props.handleWeekCallback(date)
    };

    formatWeekSelectLabel = (date, invalidLabel) => {
        let dateClone = date;

        return dateClone && dateClone.isValid()
            ? `Week of ${dateClone.startOf("isoWeek").format("MMM DD")}`
            : invalidLabel;
    };

    renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
        const { classes } = this.props;

        let dateClone = date.clone();
        let selectedDateClone = selectedDate.clone();

        const start = selectedDateClone.startOf("week").toDate();
        const end = selectedDateClone.endOf("week").toDate();

        const dayIsBetween = dateClone.isBetween(start, end, null, []);
        const isFirstDay = dateClone.isSame(start, "day");
        const isLastDay = dateClone.isSame(end, "day");

        const wrapperClassName = clsx({
            [classes.highlight]: dayIsBetween,
            [classes.firstHighlight]: isFirstDay,
            [classes.endHighlight]: isLastDay
        });

        const dayClassName = clsx(classes.day, {
            [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
            [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween
        });

        return (
            <div>
                <div className={wrapperClassName}>
                    <IconButton className={dayClassName}>
                        <span>{dateClone.format("DD")}</span>
                    </IconButton>
                </div>
            </div>
        );
    };

    render() {
        this.setState({ selectedDate: this.props.week});
        const { selectedDate } = this.state;

        return (
            <DatePicker
                value={selectedDate}
                onChange={this.handleWeekChange}
                renderDay={this.renderWrappedWeekDay}
                labelFunc={this.formatWeekSelectLabel}
                ToolbarComponent={MyToolbar}
            />
            
        );
    }
}

const styles = createStyles(theme => ({

    IconButton: {
        color: "primary"
    },
    IconButton: {
        label: {
            color: "#1f1b1e"
        },
    },
    dayWrapper: {
        position: "relative"
    },
    day: {
        width: 36,
        height: 36,
        fontSize: theme.typography.caption.fontSize,
        margin: "0 2px",
        color: "inherit"
    },
    customDayHighlight: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "2px",
        right: "2px",
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: "50%"
    },
    nonCurrentMonthDay: {
        color: theme.palette.text.disabled
    },
    highlightNonCurrentMonthDay: {
        color: "#676767"
    },
    highlight: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    endHighlight: {
        extend: "highlight",
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%"
    },
    firstHighlight: {
        extend: "highlight",
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%"
    }
}));


export default withStyles(styles)(CustomElements);
